
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SetItemsDialog extends Serenity.EntityDialog<SetItemsRow, any> {
        protected getFormKey() { return SetItemsForm.formKey; }
        protected getLocalTextPrefix() { return SetItemsRow.localTextPrefix; }

        protected form = new SetItemsForm(this.idPrefix);

    }
}